import { route, tag, type PageTour } from '../pageTour';

export const attendanceEmployeesTour: PageTour = {
  id: 'page-attendance-employees',
  version: 1,
  title: 'Employees',
  summary: 'People enrolled for face attendance, with their photos.',
  match: route('/attendance/employees'),
  steps: [
    {
      target: tag('attendance-employees-face'),
      title: 'Face ID status',
      description: 'Find employees whose face is not registered yet, so the cameras can start recognising them.',
      side: 'right',
    },
    {
      target: tag('attendance-employees-add'),
      title: 'Add employee',
      description: 'Create a new employee record, then add face photos so attendance is marked automatically.',
      side: 'bottom',
      permission: 'attendance.create_employee',
    },
    {
      target: tag('attendance-table'),
      title: 'Employee list',
      description: 'Everyone enrolled for attendance, with their Face ID and photo count. Click a name to see their attendance record.',
      side: 'top',
    },
  ],
};
